import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {MULTIPLE_ACCOUNT_SELECT_ERROR} from 'src/modules/bulk-update/update-user-group/constants';
import {allSelectedUsersAccountsSelector} from 'src/modules/user-search-result';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';


import type {AppState} from 'src/store/typedef';

type Props = {
    userIds: number[],

    showUpdateGroup: boolean,
    openAssignToGroup: () => void,
    openDischargeFromGroup: () => void,

    showUpdateUserState: boolean,
    openUpdateUserStateTool: () => void,

    showUpdateUserNewsletter: boolean,
    openUpdateUserNewsletterTool: () => void,

    showUpdateUserAccount: boolean,
    openUpdateUserAccountTool: () => void,

    showUpdateLcdAnalysis: boolean,
    openSubscribeToLcdAnalysisTool: () => void,
    openUnsubscribeFromLcdAnalysisTool: () => void,
};

export const ToolsMenu = (props: Props) => {
    const accountIds = useSelector((state: AppState) => allSelectedUsersAccountsSelector(state, props.userIds));
    const assignDisabled = useMemo(() => accountIds.length > 1, [accountIds]);

    return (
        <DropdownMenu
            anchor={({positionRef, getAnchorProps, anchorRef}) => (
                <FlatButton
                    endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                    {...getAnchorProps()}
                    ref={anchorRef}>
                    <b>Bulk Actions</b>
                </FlatButton>
            )}>
            {props.showUpdateGroup ? (
                <DropdownMenuItem caption="Set Account Group" iconAfter={Icons.ANGLE_RIGHT}>
                    <DropdownMenuItem
                        disabled={assignDisabled}
                        onClick={props.openAssignToGroup}
                        renderCaption={accountIds.length > 1
                            ? <span title={MULTIPLE_ACCOUNT_SELECT_ERROR}>Assign To Group</span>
                            : 'Assign To Group'}
                    />
                    <DropdownMenuItem
                        caption="Unassign From Group"
                        onClick={props.openDischargeFromGroup}
                    />
                </DropdownMenuItem>
            ) : null}
            {props.showUpdateLcdAnalysis ? (
                <DropdownMenuItem caption="LCD Credit Analysis" iconAfter={Icons.ANGLE_RIGHT}>
                    <DropdownMenuItem
                        caption="Subscribe"
                        onClick={props.openSubscribeToLcdAnalysisTool}
                    />
                    <DropdownMenuItem
                        caption="Unsubscribe"
                        onClick={props.openUnsubscribeFromLcdAnalysisTool}
                    />
                </DropdownMenuItem>
            ) : null}
            {props.showUpdateUserState ? (
                <DropdownMenuItem
                    caption="Set User State"
                    onClick={props.openUpdateUserStateTool}
                />
            ) : null}
            {props.showUpdateUserNewsletter ? (
                <DropdownMenuItem
                    caption="Set Newsletter Subscriptions"
                    onClick={props.openUpdateUserNewsletterTool}
                />
            ) : null}
            {props.showUpdateUserAccount ? (
                <DropdownMenuItem
                    caption="Change User's Account"
                    onClick={props.openUpdateUserAccountTool}
                />
            ) : null}
        </DropdownMenu>
    );
};
